import { useEffect } from 'react'
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from 'react-redux';
import { Encabezado } from '../../../Components/Encabezado/Encabezado';
import { IconButton } from '@mui/material';
import { MdEditDocument } from "react-icons/md";
import ExitToAppRoundedIcon from "@mui/icons-material/ExitToAppRounded";

import { colors } from '../../../utils/colors';

import { selectUserData } from "../../../redux/Login/LoginSlice";

import { 
    fetchCambiarSuccess,
    fetchGetReporteEvaluacionesFirmas, 
    fetchListaEvaluaciones, 
    selectIsLoading, 
    selectIsSuccess, 
    selectListaEvaluaciones, 
    selectMessage
} from '../../../redux/Evaluaciones/EvaluacionesSlice';

import moment from 'moment';
import swal from 'sweetalert';
import Loading from '../../../Components/Modals/Loading/Loader';

export const EvaluacionesPendientes = () => {

  // ? HOOK DISPATCH
  const dispatch = useDispatch();

  // ? HOOK SELECTOR
  const usuario = useSelector(selectUserData);
  const listaEvaluaciones = useSelector(selectListaEvaluaciones);
  const isLoading = useSelector(selectIsLoading);
  const isSuccess = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);

  // ? HOOK NAVEGACION.
  const navigate = useNavigate();

  useEffect(() => {
    
    if(isSuccess === 'success' && message?.length > 0){
        swal("Exitoso!", message, "success");
        dispatch(fetchCambiarSuccess());
    }
    else if(isSuccess === 'error' && message?.length > 0){
        swal("Error", message, "error");
        dispatch(fetchCambiarSuccess());
    }

  }, [isSuccess, message])

  // * FUNCION PARA NAVEGACION.
  const NavigateTo = (ano) => {
    navigate(`/evaluaciones/misevaluaciones/${ano}`);
  }

  useEffect(() => {
    dispatch(fetchListaEvaluaciones(usuario?.Id));
  }, [usuario])

  return (
    <Encabezado title={'Mis Evaluaciones'} >
        {
            listaEvaluaciones.map((item, index) => (
                <div className="row mt-2 mx-auto" key={index}>
                    <div className="card mb-2">
                        <div className="row g-0">
                            <div className="col-1 text-center mt-3 mb-3">
                                <p className="card-text fw-bold text-14">Año</p>
                                <h6 className="text-14">{item.anio}</h6>
                            </div>
        
                            <div className="col-3">
                                <div className="text-center mt-3 mb-3">
                                    <p className="card-text fw-bold text-14">Inicio de período:</p>
                                    <h6 className="text-14">{moment(item.iniciodePeriodo).format(`D [de] MMMM`)}</h6>
                                </div>
                            </div>
        
                            <div className="col-2">
                                <div className="text-center mt-3 mb-3">
                                    <p className="card-text fw-bold text-14">Cantidad de Evaluaciones</p>
                                    <h6 className="text-14">{item.cantidadEvaluaciones}</h6>
                                </div>
                            </div>
        
                            <div className="col-2">
                                <div className="text-center text-14 mt-3 mb-3">
                                    <p className="card-text fw-bold">Completadas</p>
                                    <h6 className="text-14">{item.completadas}</h6>
                                </div>
                            </div>
        
                            <div className="col-2">
                                <div className="text-center mt-3 mb-3">
                                    <p className="card-text fw-bold text-14">Terminadas (cerradas)</p>
                                    <h6 className="text-14">{item.terminadasCerradas}</h6>
                                </div>
                            </div>
        
                            <div className="col-2">
                                <div className='mt-2 mb-2 d-flex justify-content-end'> 
                                    <IconButton onClick={() => dispatch(fetchGetReporteEvaluacionesFirmas())} hidden={parseInt(usuario?.GrupoOcupacionalId ?? 0) !== 5} title='Firmas de Acuerdo de Desempeño' className='mt-4'>
                                        <MdEditDocument style={{color: colors.rojoMem}} />
                                    </IconButton> 
                                    <IconButton className='mt-4' onClick={() => NavigateTo(item.anio)}>
                                        <ExitToAppRoundedIcon style={{color: colors.azulMem}} />
                                    </IconButton>                    
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            ))
        }

        <Loading open={isLoading} />
    </Encabezado>
  )
}
